var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalender(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.999,
    height: 20,
    viewBox: "0 0 19.999 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_31",
    "data-name": "Union 31",
    d: "M2.778,20A2.781,2.781,0,0,1,0,17.222V4.445A2.782,2.782,0,0,1,2.778,1.667H4.444V0H5.555V1.667h8.888V0h1.111V1.667h1.667A2.782,2.782,0,0,1,20,4.444V17.222A2.781,2.781,0,0,1,17.221,20ZM1.112,17.221a1.668,1.668,0,0,0,1.667,1.666H17.221a1.667,1.667,0,0,0,1.666-1.666v-10H1.112Zm0-12.776V6.111H18.887V4.444a1.668,1.668,0,0,0-1.667-1.666H15.554V3.889H14.443V2.778H5.555v1.11H4.445V2.777H2.778A1.668,1.668,0,0,0,1.112,4.444ZM14,17.467v-2h2v2Zm-3.333,0v-2h2v2Zm-3.334,0v-2h2v2ZM4,17.467v-2H6v2Zm10-3v-2h2v2Zm-3.333,0v-2h2v2Zm-3.334,0v-2h2v2ZM4,14.467v-2H6v2Zm10-3v-2h2v2Zm-3.333,0v-2h2v2Zm-3.334,0v-2h2v2ZM4,11.467v-2H6v2Z",
    fill: "#3b4452"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalender);
export default __webpack_public_path__ + "static/media/calender.f51f650cbd6a8b6ffb1617032ff6c0ec.svg";
export { ForwardRef as ReactComponent };